// Markdown as plain text, for pasting into an email or a board paper: no #, ** or * left behind.
// Pure: no DOM. Headings keep their words on a line of their own; bullets become "•"; a link keeps
// its text and address; emphasis, code marks, quote marks and rules are dropped.

export function markdownToPlainText(md: string): string {
  const lines = md.replace(/\r\n?/g, "\n").split("\n").map((raw) => {
    let line = raw;
    if (/^\s*([-*_])(\s*\1){2,}\s*$/.test(line)) return ""; // horizontal rule
    line = line.replace(/^\s{0,3}#{1,6}\s+/, "").replace(/\s+#+\s*$/, ""); // heading marks
    line = line.replace(/^(\s*)>\s?/, "$1"); // block quote
    line = line.replace(/^(\s*)[-*+]\s+/, "$1• "); // bullet
    line = line.replace(/!\[([^\]]*)\]\([^)]*\)/g, "$1"); // image: its alt text
    line = line.replace(/\[([^\]]+)\]\(([^)\s]+)[^)]*\)/g, (_m, text: string, url: string) => (text === url ? url : `${text} (${url})`));
    line = line.replace(/(\*\*|__)(?=\S)([\s\S]*?\S)\1/g, "$2"); // bold
    line = line.replace(/(^|[^\w*])\*(?=\S)([^*]*?\S)\*(?!\w)/g, "$1$2"); // italic *x*
    line = line.replace(/(^|[^\w])_(?=\S)([^_]*?\S)_(?!\w)/g, "$1$2"); // italic _x_ (never inside words)
    line = line.replace(/`([^`]+)`/g, "$1"); // inline code
    return line;
  });
  return lines.join("\n").replace(/\n{3,}/g, "\n\n").trim();
}
